import React, { useContext } from 'react'
import { string, func } from 'prop-types'
import classNames from 'classnames'
import { productsDataType } from 'models/propTypes'
import { useTranslation } from 'react-i18next'
import * as modes from 'models/ui/constants'
import ItemDetailsViewContainer from 'containers/designSidepanel/ItemDetailsViewContainer'
import { MY_ITEMS_BROWSE_NUM_COLUMNS } from 'models/ui/constants'
import Products from 'components/designSidepanel/Products'
import SugarcubeContext from 'apps/SugarcubeContext'

require('./MyItemsBrowseView.scss')

const MyItemsBrowseView = ({ addedToRoomItems, mode, addRoomToBag }) => {
    const { t } = useTranslation()
    const { isKiosk } = useContext(SugarcubeContext)
    const isDetailsVisible = mode === modes.DESIGN_SIDEPANEL_MODE_MYITEMS_DETAILS

    return (
        <div className="MyItemsBrowse">
            {isDetailsVisible && (
                <div className={classNames('detailsWrapper', { isDetailsVisible })}>
                    <ItemDetailsViewContainer />
                </div>
            )}
            <div className={classNames('browseWrapper', { isBrowseVisible: !isDetailsVisible })}>
                <div className="itemSelection">
                    <div className="items">
                        <Products furnituresData={addedToRoomItems} columnCount={MY_ITEMS_BROWSE_NUM_COLUMNS} />
                    </div>
                </div>
                {!isKiosk && (
                    <div className="checkOut">
                        <button onClick={addRoomToBag}>{t('design.add room to shopping bag')}</button>
                    </div>
                )}
            </div>
        </div>
    )
}

MyItemsBrowseView.propTypes = {
    addedToRoomItems: productsDataType.isRequired,
    mode: string.isRequired,
    addRoomToBag: func.isRequired,
}

export default MyItemsBrowseView
